/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import { CARE_COMPANY_ADD_URL_LIST } from '../../constants/CARE_COMPANY';
import { isEmpty } from '../../utils/lodashExtend';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import { addTaxpayerAddSiteInfo, editTaxpayerAddSiteInfo } from '../../apis/tax-portal/taxpayer';
import { toast } from '../../utils/toast';

const defaultForm = {
  title: "",// 타이틀
  url: "", // URL
  id: "", // id
  pwd: "", // password
};

const TaxpayerAddSiteInfo = (props) => {
  const { post, open, setOpen, submit, orgMode, taxpayer, company } = props;
  const [mode, setMode] = useState(orgMode);
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([]);


  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm);
    //setPost(null)
  };
  const _submit = (_form) => {
    const { title, url, id, pwd, idx: postIdx } = _form;
    const form = {
      title, url, id, pwd
    };

    if (mode === "create") {
      systemAlert(`"${form.title}" 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {

              addTaxpayerAddSiteInfo(company.managerCompanyIdx, taxpayer.idx, form)
                .then(() => {
                  toast.success(`정상적으로 등록되었습니다.`);
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              editTaxpayerAddSiteInfo(company.managerCompanyIdx, taxpayer.idx, postIdx, form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    }


  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(orgMode);
    if (post) {
      const form = {
        ...post,
      };
      setForm(form);
      setOriginForm(form);
    } else {
      setForm({
        ...defaultForm,
      });
      setOriginForm({
        ...defaultForm,
      });
    }
  }, [open, post, orgMode]);

  useEffect(() => {
    setFields([
      [
        {
          title: "항목선택", type: "select",
          onChange: (e) => {
            e.preventDefault();
            const item = CARE_COMPANY_ADD_URL_LIST.find((data) => data.value === e.target.value);
            if (item) {
              if (!isNaN(Number(item.value))) {
                setForm({
                  ...form,
                  title: Number(item.value) === 1 ? "" : item.label,
                  url: "",
                });
              } else {
                setForm({
                  ...form,
                  title: isEmpty(item.value) ? "" : item.label,
                  url: item.value,
                });
              }
            } else {
              setForm({
                ...form,
                title: "",
                url: "",
              });
            }
          },
          options: {
            list: CARE_COMPANY_ADD_URL_LIST,
          },
        },
      ],
      [
        {
          title: "타이틀", key: "title", type: "input", required: true,
        },
      ],
      [
        {
          title: "URL", key: "url", type: "input", placeholder: "https://, http// 포함 입력",
        },
      ],
      [
        {
          title: "아이디", key: "id", type: "input",
        },
        {
          title: "비밀번호", key: "pwd", type: "password",
        },
      ],
    ]);
  }, [mode]);

  useEffect(() => {
    setButtons([
      {
        color: 'text',
        label: '닫기',
        onClick: cancel
      },
      {
        isHide: mode !== 'modify',
        label: '수정',
        onClick: handleSubmit
      },
      {
        isHide: mode !== 'create',
        label: '등록',
        onClick: handleSubmit
      }
    ]);
  }, [mode]);
  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="client-write">
        <ModalHeader>{post ? <>{post.title}</> : '추가정보 입력'} </ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          // submitText={mode === 'create' ? '작성' : '수정'}
          // submit={handleSubmit}
          // cancel={cancel}
          buttons={buttons}
        />
      </div>
    </Modal>
  );
};


export default TaxpayerAddSiteInfo;